import { PackingSTItems } from "./packing-stock-transfer-items.model";
import { ApiProperty } from '@nestjs/swagger';
import { IsEnum, IsNotEmpty } from "class-validator";
import { GlobalStatus,  TransferMethodEnum } from "@gtpl/shared-models/common-models";
export class PackingStockTransferData {
    @ApiProperty()
    fromPlant: number;
    @ApiProperty()
    toPlant: number;
    @ApiProperty()
    transferredDate: Date;
    @ApiProperty()
    note: string;
    @ApiProperty({ enum: Object.values(GlobalStatus) })
    @IsNotEmpty()
    @IsEnum(GlobalStatus)
    transferType: GlobalStatus;
    @ApiProperty({ enum: Object.values(TransferMethodEnum) })
    @IsNotEmpty()
    @IsEnum(TransferMethodEnum)
    transferMethod: TransferMethodEnum;
    @ApiProperty({ type: [PackingSTItems] })
    stockTransferItems?: PackingSTItems[];
    @ApiProperty()
    packingStockTransferId?: number;
    @ApiProperty()
    saleOrderId?: number;
    @ApiProperty()
    saleOrderItemId?: number;
    @ApiProperty()
    createdUser: string;
    @ApiProperty()
    updatedUser?: string;
    @ApiProperty()
    dcNumber?: string;
    @ApiProperty()
    mrnNumber?: string;
    @ApiProperty()
    indentId?: number;
    @ApiProperty()
    indentMaterialPreparationId?: number;
    @ApiProperty()
    isPreparedMaterial?:string;
}